import StandardBill from './StandardBill';
export default {
    infoData: {
        companyNamek: '',
        totalAmt: '',
        amountPaid: '',
        siteName: '',
        fineAmt: '',
        currencyCode: '',
        courierNumber: '',
        courierServicesCompany: '',
        totalAmount: '',
        totalAmountText: '',
        fineAfterAmt: '',
        chargeoffPreAmt: '',
        depositAmt: '',
        chargeoffArAmt: '',
        apRealAmt: '',
        localTotalAmt: ''
    },
    invoiceItems: [
        {
            prop: 'invoiceCode',
            label: '发票代码',
            type: 'normal'
        },
        {
            prop: 'invoiceSerial',
            label: '发票号码',
            type: 'normal'
        },
        {
            prop: 'invoiceTypeName', // SYS_SC_INVOICE_TYPE
            label: '发票类型',
            type: 'normal'
        },
        {
            prop: 'openInvoiceCompany',
            label: '开票单位',
            type: 'normal'
        },
        {
            prop: 'amt',
            label: '发票金额',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            type: 'normal'
        },
        {
            prop: 'tax',
            label: '税额',
            type: 'normal'
        },
        {
            prop: 'fee',
            label: '不含税金额',
            type: 'normal'
        },
        {
            prop: 'openInvoiceDate',
            label: '开票日期',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'invoiceSourceName',
            label: '来源',
            type: 'normal'
        },
        {
            prop: 'createTime',
            label: '上传时间',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    invoiceLists: [],
    taxRateData: [],
    tableDataItems: [
        {
            prop: 'feeTaskCode',
            label: '任务单号',
            type: 'normal'
        },
        {
            prop: 'feeTaskTypeText',
            label: '任务类型',
            type: 'normal'
        },
        {
            prop: 'businessTypeText',
            label: '业务类型',
            type: 'normal'
        },
        {
            prop: 'sumFee',
            label: '不含税金额',
            type: 'normal',
            status: 'redStyle'
        },
        {
            prop: 'taxRate',
            label: '税率',
            type: 'normal'
        },
        {
            prop: 'sumTax',
            label: '税额',
            type: 'normal'
        },
        {
            prop: 'sumAmt',
            label: '含税金额',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    networkInfoItems: [
        {
            prop: 'type',
            label: '类型',
            type: 'normal'
        },
        {
            prop: 'supName',
            label: '服务商名称',
            type: 'normal'
        },
        {
            prop: 'engineerCode',
            label: '工程师编号',
            type: 'normal'
        },
        {
            prop: 'engineerName',
            label: '工程师姓名',
            type: 'normal'
        },
        {
            prop: 'payableTaxAmount',
            label: '应收含税金额',
            type: 'normal'
        },
        {
            prop: 'penaltyDeductionAmount',
            label: '罚扣款总额',
            type: 'normal'
        },
        {
            prop: 'payTaxAmount',
            label: '实收含税金额',
            type: 'normal'
        },
        {
            prop: 'payStatus',
            label: '状态',
            type: 'normal',
            status: 'redStyle'
        }
    ],
    contractInfoItems: [
        {
            prop: 'contractCode',
            label: '合同编号',
            type: 'normal'
        },
        {
            prop: 'contractName',
            label: '合同名称',
            type: 'normal'
        },
        {
            prop: 'contractStatus',
            label: '合同状态',
            type: 'normal'
        },
        {
            prop: 'businessTypeSupplier',
            label: '合同业务类型',
            type: 'normal'
        },
        {
            prop: 'validTime',
            label: '生效日期',
            type: 'normal'
        },
        {
            prop: 'failTime',
            label: '失效日期',
            type: 'normal'
        }
    ],
    checkCancelInfoItems: [
        {
            prop: 'typeName',
            label: '核销类型',
            type: 'normal'
        },
        {
            prop: 'billNo',
            label: '核销单号',
            type: 'normal'
        },
        {
            prop: 'amt',
            label: '核销金额',
            type: 'normal'
        }
    ],
    process: {
        step: [
            {
                id: '',
                titleName: '确认账单',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '',
                carTimes: ''
            },
            {
                id: '',
                titleName: '开票日期',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            {
                id: '',
                titleName: '收票日期',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            },
            {
                id: '',
                titleName: '付款日期',
                images: {
                    active: 1,
                    notActive: 2
                },
                carName: '1',
                carTimes: ''
            }
        ]
    },
    distributionColumnItem: [
        {
            prop: 'orderCode',
            label: '发车单号',
            type: 'normal'
        },
        {
            prop: 'lineName',
            label: '线路',
            type: 'normal'
        },
        {
            prop: 'etdoVehicleCard',
            label: '车牌号',
            type: 'normal'
        },
        {
            prop: 'etveName',
            label: '车型',
            type: 'normal'
        },
        {
            prop: 'volume',
            label: '体积',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实际发货数量',
            type: 'normal'
        },
        {
            prop: 'ettaRateMileage',
            label: '配送导航里程',
            type: 'normal'
        },
        {
            prop: 'businessTime',
            label: '发车时间',
            type: 'normal'
        },
        {
            prop: 'feeName',
            label: '调整费用名称',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '确认费用金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '备注',
            type: 'input'
        },
        {
            prop: 'replyMsg',
            label: '安得回复',
            type: 'input'
        }
    ],
    networkDotColumnItem: [
        {
            prop: 'orderCode',
            label: '业务单号',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实际数量',
            type: 'normal'
        },
        {
            prop: 'businessTime',
            label: '签收/完成时间',
            type: 'normal'
        },
        {
            prop: 'engineerCode',
            label: '工程师编码',
            type: 'normal'
        },
        {
            prop: 'engineerName',
            label: '工程师名称',
            type: 'normal'
        },
        {
            prop: 'engineerFee',
            label: '工程师费用',
            type: 'normal'
        },
        {
            prop: 'netFee',
            label: '网点费用',
            type: 'normal'
        },
        {
            prop: 'feeName',
            label: '调整费用名称',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '供应商确认费用金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '供应商备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '沟通回复',
            type: 'normal'
        }
    ],
    ticketDeductColumnItem: [
        {
            prop: 'supFineNo',
            label: '罚扣款单号',
            type: 'normal'
        },
        {
            prop: 'totalAmt',
            label: '扣款金额',
            type: 'normal'
        },
        {
            prop: 'operationTypeText',
            label: '业务类型',
            type: 'normal'
        },
        {
            prop: 'remark',
            label: '备注',
            type: 'normal'
        }
    ],
    expenseColumnItems: StandardBill.expenseColumnItems,
    netWorkDotDetailColumnItem: StandardBill.netWorkDotDetailColumnItem
};
